import React, { useContext, useEffect, useRef, useState } from "react";
import Nav from "../layouts/Nav";
import { PhrasesContext } from "../context/phrasesContext";
import Breadcrumb from "../components/breadCrumb";
import { Link } from "react-router-dom";
import CaseDetailsUpdated from "../components/CaseDetailsUpdated";
import { RequesterContext } from "../context/requesterContext";
import { Loader } from "../components/utils";
import SharedModal from "../components/happiness/SharedModal";
import { v4 as uuidv4 } from "uuid";
import MapPicker from "../components/CaseDetailsUpdated/MapPicker";
import { useForm } from "react-hook-form";

const RequestPage = ({ children, navbarRef }) => {
  const [lang, setLang] = useState("");

  const [enPhrase, arPhrase] = useContext(PhrasesContext);
  const [disclosures, setDisclosures] = useState([{ id: 1 }]);
  const [disclosureData, setDisclosureData] = useState({});

  const [requesterInfo] = useContext(RequesterContext);
  const [loading, setLoading] = useState(false);
  const [submitAllRequests, setSubmitAllRequests] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmittingDocuments, setIsSubmittingDocuments] = useState({});

  const [isDeleteAllRequestes, setIsDeleteAllRequestes] = useState(false);
  const [somethingWentWrong, setSomethingWentWrong] = useState(false);
  const { setValue, getValues } = useForm();
  const [isSticky, setIsSticky] = useState(false);
  const [navHeight, setNavHeight] = useState(0);
  const [isNavSticky, setIsNavSticky] = useState(false);
  const [isHeaderSticky, setIsHeaderSticky] = useState(false);
  const [showMap, setShowMap] = useState(false);
  const [selectedDisclosureId, setSelectedDisclosureId] = useState(null);
  const headerRef = useRef(null);
  const navRef = useRef(null);
  const parentDisclosureRef = useRef(null);

  const [scrollToNewDisclosure, setScrollToNewDisclosure] = useState(false);

  const [mapKey, setMapKey] = useState(0);

  const addNewDisclosure = () => {
    setDisclosures((prev) => [...prev, { id: uuidv4() }]);
    setScrollToNewDisclosure(true); // trigger scroll after render
  };

  useEffect(() => {
    const lang = window.localStorage.getItem("lang");

    if (lang === "en") {
      document.body.dir = "ltr";
      setLang("en");
    } else {
      document.body.dir = "rtl";
      setLang("ar");
    }
  }, []);

  useEffect(() => {
    // Measure Nav height dynamically
    if (navRef.current) {
      setNavHeight(navRef.current.offsetHeight);
    }

    const handleResize = () => {
      if (navRef.current) {
        setNavHeight(navRef.current.offsetHeight);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (navRef.current) {
        if (window.scrollY > 0) {
          setIsNavSticky(true);
        } else {
          setIsNavSticky(false);
        }
      }

      if (headerRef.current) {
        const offset = headerRef.current.offsetTop;
        if (window.scrollY > offset - navHeight) {
          setIsHeaderSticky(true);
        } else {
          setIsHeaderSticky(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [navHeight]);

  const changeLanguage2 = (lang) => {
    if (lang === "en") {
      document.body.dir = "rtl";
      setLang("ar");
      window.localStorage.setItem("lang", "ar");
    } else {
      document.body.dir = "ltr";
      setLang("en");
      window.localStorage.setItem("lang", "en");
    }
    window.location.reload();
  };

  const openPDF = () => {
    // Replace 'sample.pdf' with the actual path to your PDF file
    if (lang === "en") {
      window.open("/assets/img/Application Fees List.pdf", "_blank");
    } else {
      window.open("/assets/img/قائمة رسوم الطلبات.pdf", "_blank");
    }
  };

  const handleSubmitAll = async () => {
    if (caseDetailsRef.current) {
      const hasErrors = await caseDetailsRef.current.hasFormErrors();

      if (hasErrors) {
        // ❌ Don't open the popup
        console.log("Form has validation errors.");
        await caseDetailsRef.current.scrollToFirstErrorDisclosure();
        return;
      }

      // ✅ If no validation errors, show confirmation popup
      setSubmitAllRequests(true);
    }
  };

  const caseDetailsRef = useRef(null); // Create ref for child component
  const handleRefresh = () => {
    window.location.reload();
  };

  console.log("submitAllRequests", submitAllRequests);
  console.log("isSubmitting", isSubmitting);

  const somethingWentWrongHandler = () => {
    window.location.reload();
    setSomethingWentWrong(false);
  };

  const openMapForDisclosure = (disclosureId) => {
    setSelectedDisclosureId(disclosureId);
    setMapKey((prev) => prev + 1); // force fresh MapPicker
    setShowMap(true);
  };

  const handleLocationSelect = (location, disclosureId, locationName) => {
    console.log("disclosureId", disclosureId);
    console.log("locationName", locationName);

    setDisclosureData((prev) => ({
      ...prev,
      [disclosureId]: {
        ...prev[disclosureId],
        location: `${location.lat}, ${location.lng}`,
        latitude: `${location.lat}`,
        longitude: `${location.lng}`,
        locationName: locationName, // ← make sure you save it!
      },
    }));
    setValue(`location-${disclosureId}`, `${location.lat}, ${location.lng}`);
    setShowMap(false);
  };

  useEffect(() => {
    if (showMap) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [showMap]);

  useEffect(() => {
    let observer;

    if (showMap) {
      document.body.style.overflow = "hidden";

      observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.attributeName === "style" &&
            document.body.style.overflow !== "hidden"
          ) {
            document.body.style.overflow = "hidden"; // force it back
          }
        });
      });

      observer.observe(document.body, {
        attributes: true,
        attributeFilter: ["style"],
      });
    } else {
      document.body.style.overflow = "unset";
      if (observer) observer.disconnect();
    }

    return () => {
      if (observer) observer.disconnect();
      document.body.style.overflow = "unset";
    };
  }, [showMap]);
  const [disclosureCount, setDisclosureCount] = useState(0);
  useEffect(() => {
    setDisclosureCount(Object.keys(disclosureData).length);
  }, [disclosureData]);

  console.log("(disclosureData)?.length", Object.keys(disclosureData)?.length);

  return (
    <>
      <div
        ref={navRef}
        className={`fixed w-full z-50 transition-all duration-300 `}
      >
        <Nav
          navbarRef={navbarRef}
          lang={lang}
          enPhrase={enPhrase}
          arPhrase={arPhrase}
          changeLanguage2={changeLanguage2}
          hideUpload={true}
        />
      </div>

      <div
        className={`bottom-0  top-0 right-0 fixed bg-white w-full h-auto pt-[72px] xl:pt-[153px] overflow-x-hidden z-[30] ${
          showMap ? " translate-y-0" : "flex translate-y-full"
        } ease-in-out duration-500`}
      >
        <MapPicker
          key={mapKey} // 👈 this forces full re-render on every open
          onClose={() => setShowMap(false)}
          // onSelect={handleLocationSelect}
          onSelect={(location, disclosureId, locationName) =>
            handleLocationSelect(location, disclosureId, locationName)
          }
          disclosureId={selectedDisclosureId}
          lang={lang}
          setValue={setValue}
          navbarRef={navbarRef}
          enPhrase={enPhrase}
          arPhrase={arPhrase}
          changeLanguage2={changeLanguage2}
          hideUpload={true}
          navHeight={navHeight}
          disclosureData={disclosureData}
        />
      </div>

      <div>
        {somethingWentWrong && (
          <div className="w-full bg-[#E23636] pt-[88px] xl:pt-[153px]">
            <div className="w-full mx-auto xl:max-w-[1200px] lg:max-w-[960px] md:px-0 flex flex-row items-center justify-between py-[16px] px-[16px] lg:px-0">
              <div className="flex flex-row items-center justify-center gap-[16px]">
                <img
                  src="/assets/img/errorRequest.svg"
                  alt="Error"
                  className="Error"
                />
                <p className="text-[#fff] text-[14px] md:text-[20px] font-Almarai">
                  {lang === "en"
                    ? enPhrase["lblTechnicalError"]
                    : arPhrase["lblTechnicalError"]}
                </p>
              </div>
              <div
                className="flex items-center cursor-pointer"
                onClick={somethingWentWrongHandler}
              >
                <img
                  src="/assets/img/close-icon.svg"
                  alt="close-icon"
                  className=""
                />
              </div>
            </div>
          </div>
        )}
        <div
          // ref={headerRef}
          className={`md:py-[20px] transition-all duration-300 pt-[72px] md:pt-[89px] xl:pt-[167px] ${
            isHeaderSticky
              ? "fixed left-0 w-full bg-white shadow-md z-40"
              : "relative bg-gold-10"
          } ${somethingWentWrong && "!pt-[8px]"}`}
          // style={{ top: isHeaderSticky ? `${navHeight}px` : "unset" }} // Dynamic top
        >
          <div className="w-full py-[20px] mx-auto xl:max-w-[1200px]  lg:max-w-[960px] px-[16px] lg:px-0    flex flex-col xl:py-0">
            <div className={`${isHeaderSticky ? "hidden" : ""}`}>
              <Breadcrumb
                title={
                  lang === "en"
                    ? enPhrase["lblFollowCases"]
                    : arPhrase["lblFollowCases"]
                }
                last={
                  lang === "en"
                    ? enPhrase["lblNewApplication"]
                    : arPhrase["lblNewApplication"]
                }
                isRequest
              />
            </div>
            <div className="flex justify-between flex-col md:flex-row gap-[16px] ">
              <div className="flex gap-[16px] items-center">
                <Link
                  to="/case-overview"
                  className="md:w-[32px] md:h-[32px] w-[40px] h-[40px] border-[1px] border-solid rounded-[4px] flex items-center justify-center cursor-pointer bg-[#F6F4E6]"
                >
                  <img
                    src="/assets/img/arrow--down.svg"
                    alt="back-icon"
                    className={`${lang === "en" ? "rotate-180" : ""}`}
                  />
                </Link>
                <h3 className="font-Almarai font-bold text-[20px] leading-[24px] text-[#010202]">
                  {lang === "en"
                    ? enPhrase["lbl_Create_orders"]
                    : arPhrase["lbl_Create_orders"]}
                </h3>
              </div>
              <div className="flex flex-row gap-[16px] items-center justify-between md:justify-end">
                <button
                  onClick={openPDF}
                  className="w-[200px] flex flex-row items-center justify-center gap-[8px]  h-[40px] font-bold font-Almarai text-[14px] bg-[#E9DCC2] md:bg-[#fff] py-3 px-3 rounded-[4px]  text-[#815327]"
                >
                  <img
                    src="/assets/img/Money-Wave.svg"
                    alt="archive"
                    className="w-5 h-5"
                  />
                  <span>
                    {lang === "en"
                      ? enPhrase["ApplicationFeeList"]
                      : arPhrase["ApplicationFeeList"]}
                  </span>
                </button>
                <img
                  src="/assets/img/add-request/dashMain.svg"
                  alt="dash"
                  className="hidden md:flex"
                />
                <button
                  className={`w-[131px] flex flex-row items-center justify-center gap-[8px]  h-[40px] font-bold font-Almarai text-[14px]  bg-[#B68A35]  rounded-[4px]  text-[#fff] ${
                    Object.keys(disclosureData)?.length >= 9
                      ? "cursor-not-allowed opacity-50"
                      : ""
                  }`}
                  onClick={addNewDisclosure}
                  disabled={Object.keys(disclosureData)?.length >= 9}
                >
                  <img
                    src="/assets/img/add-request/vectorAdd.svg"
                    alt="archive"
                    className="w-[20px] h-[20px]"
                  />
                  <span>
                    {lang === "en"
                      ? enPhrase["lblAddRequest"]
                      : arPhrase["lblAddRequest"]}
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gold-10 min-h-screen">
          <div className="w-full mx-auto xl:max-w-[1200px] lg:max-w-[960px] px-[16px] lg:px-0 flex flex-col xl:py-0">
            <div>
              {/* <CaseDetails lang={lang} disclosures={disclosures} setDisclosures={setDisclosures} addNewDisclosure={addNewDisclosure}/> */}
              <CaseDetailsUpdated
                ref={caseDetailsRef} // Pass ref to child component
                lang={lang}
                disclosures={disclosures}
                setDisclosures={setDisclosures}
                addNewDisclosure={addNewDisclosure}
                requesterInfo={requesterInfo}
                setLoading={setLoading}
                loading={loading}
                setSubmitAllRequests={setSubmitAllRequests}
                submitAllRequests={submitAllRequests}
                handleSubmitAll={handleSubmitAll}
                setSomethingWentWrong={setSomethingWentWrong}
                setIsSubmitting={setIsSubmitting}
                parentDisclosureRef={parentDisclosureRef}
                scrollToNewDisclosure={scrollToNewDisclosure}
                setScrollToNewDisclosure={setScrollToNewDisclosure}
                setDisclosureData={setDisclosureData}
                disclosureData={disclosureData}
                setShowMap={setShowMap}
                handleLocationSelect={handleLocationSelect}
                openMapForDisclosure={openMapForDisclosure}
                setIsSubmittingDocuments={setIsSubmittingDocuments}
                isSubmittingDocuments={isSubmittingDocuments}
              />
            </div>
          </div>
        </div>

        <div className="h-[167px] xl:h-[88px] bg-[#fff] py-[16px] flex items-center sticky bottom-0">
          {window && window.innerWidth <= 1024 ? (
            <div className="w-full flex flex-col items-center justify-between gap-[12px] px-[16px]">
              <div className="w-full flex flex-row items-center justify-between">
                <div className="flex flex-row items-center gap-[16px]">
                  <img
                    src="/assets/img/add-request/UAEPassIcon.svg"
                    alt="UAEPassIcon"
                    className="w-[48px] h-[48px]"
                  />
                  <div className="flex flex-col gap-[4px] items-start justify-start max-w-[200px]  whitespace-nowrap truncate">
                    <p className="w-full font-Almarai font-bold text-[14px] leading-[20px] text-[#0E0D0C]">
                      {requesterInfo?.name}
                    </p>
                    <p
                      className="font-Almarai font-normal text-[12px] leading-[16px] text-[#6F6A62]"
                      dir="ltr"
                    >
                      {requesterInfo?.mobile}
                    </p>
                    <p className="w-full font-Almarai font-normal text-[12px] leading-[16px] text-[#6F6A62]">
                      {requesterInfo?.email}
                    </p>
                  </div>
                </div>
                <img
                  src="/assets/img/add-request/lineResponsiveFooter.svg"
                  alt="line"
                  className=""
                />
                <div
                  className={`flex flex-col items-center ${
                    lang === "en" ? "" : "max-w-[42px]"
                  }`}
                >
                  <p
                    className={`font-Almarai font-bold text-[11px] leading-[14px] text-[#0E0D0C] break-words`}
                  >
                    {lang === "en"
                      ? enPhrase["lblRequestesAdded"]
                      : arPhrase["lblRequestesAdded"]}
                  </p>
                  <p className="w-[20px] h-[20px] flex items-center justify-center">
                    {disclosureCount}
                  </p>
                </div>
              </div>
              <div className="w-full border-[0.5px]  border-[#E6E6E6]"></div>
              <div className="w-full flex flex-row items-center justify-between gap-[16px]">
                <button
                  className="w-[162px] h-[44px] bg-[#E9DCC2] rounded-[4px] px-[10px] cursor-pointer"
                  onClick={() => setIsDeleteAllRequestes(true)}
                >
                  <p className="font-Almarai font-bold text-[14px] leading-[20px] text-[#361E12] cursor-pointer">
                    {lang === "en"
                      ? enPhrase["btnCancel"]
                      : arPhrase["btnCancel"]}
                  </p>
                </button>
                <button
                  className={`w-[162px] h-[44px] bg-[#B68A35] rounded-[4px] px-[10px] ${
                    (isSubmitting || Object.values(isSubmittingDocuments).some((val) => val === true)) && "cursor-not-allowed bg-gray-400"
                  }`}
                  // onClick={handleSubmitAll}
                  // onClick={()=>setSubmitAllRequests(true)}
                  // disabled={submitAllRequests}
                  onClick={() => !isSubmitting && handleSubmitAll()}
                  disabled={
                    isSubmitting ||
                    Object.values(isSubmittingDocuments).some((val) => val === true)
                  } // Disable button during submission // Disable button during submission
                >
                  <p className="font-Almarai font-bold text-[14px] leading-[20px] text-[#FFFFFF]">
                    {lang === "en"
                      ? enPhrase["lblSubmitRequests"]
                      : arPhrase["lblSubmitRequests"]}
                  </p>
                </button>
              </div>
            </div>
          ) : (
            <div className="w-full mx-auto max-w-[1200px] 2xl:max-w-[1200px] lg:max-w-[960px] px-[24px] md:px-0  flex flex-col gap-[16px] md:gap-0 md:flex-row justify-between xl:py-0">
              <div className="flex flex-row items-center gap-[16px]">
                <img
                  src="/assets/img/add-request/UAEPassIcon.svg"
                  alt="UAEPassIcon"
                  className="w-[48px] h-[48px]"
                />
                <div className="flex flex-col gap-[4px] items-start justify-start max-w-[200px]  whitespace-nowrap truncate">
                  <p className="w-full font-Almarai font-bold text-[14px] leading-[20px] text-[#0E0D0C]">
                    {requesterInfo?.name}
                  </p>
                  <p
                    className="font-Almarai font-normal text-[12px] leading-[16px] text-[#6F6A62]"
                    dir="ltr"
                  >
                    {requesterInfo?.mobile}
                  </p>
                  <p className="w-full font-Almarai font-normal text-[12px] leading-[16px] text-[#6F6A62]">
                    {requesterInfo?.email}
                  </p>
                </div>
              </div>

              <div className="flex flex-row gap-[16px] items-center">
                <div className="flex flex-row gap-[4px] items-center">
                  <p className="font-Almarai font-bold text-[12px] leading-[20px] text-[#0E0D0C]">
                    {lang === "en"
                      ? enPhrase["lblNumRequetes"]
                      : arPhrase["lblNumRequetes"]}
                  </p>
                  <p className="w-[20px] h-[20px] flex items-center justify-center">
                    {disclosureCount}
                  </p>
                </div>
                <img
                  src="/assets/img/add-request/dash.svg"
                  alt="dash"
                  className="w-[1px] h-[20px]"
                />
                <p
                  className="font-Almarai font-bold text-[14px] leading-[20px] text-[#361E12] cursor-pointer"
                  onClick={() => setIsDeleteAllRequestes(true)}
                >
                  {lang === "en"
                    ? enPhrase["btnCancel"]
                    : arPhrase["btnCancel"]}
                </p>
                <button
                  className={`w-[162px] h-[44px] bg-[#B68A35] rounded-[4px] px-[10px] ${
                    (isSubmitting || Object.values(isSubmittingDocuments).some((val) => val === true)) && "cursor-not-allowed bg-gray-400"
                  }`}
                  // onClick={handleSubmitAll}
                  // onClick={()=>setSubmitAllRequests(true)}
                  // disabled={submitAllRequests}
                  onClick={() => !isSubmitting && handleSubmitAll()}
                  disabled={
                    isSubmitting ||
                    Object.values(isSubmittingDocuments).some((val) => val === true)
                  } // Disable button during submission
                >
                  <p className="font-Almarai font-bold text-[14px] leading-[20px] text-[#FFFFFF]">
                    {lang === "en"
                      ? enPhrase["lblSubmitRequests"]
                      : arPhrase["lblSubmitRequests"]}
                  </p>
                </button>
              </div>
            </div>
          )}
        </div>

        {isDeleteAllRequestes && (
          <SharedModal isAdmissionLoading>
            <div className="px-[32px] py-[16px] md:py-0 flex flex-col gap-[32px]">
              <div className="flex flex-col justify-center items-center gap-[16px]">
                <p
                  className={`text-[24px] font-Almarai text-[#010202] font-bold text-center ${
                    lang === "en"
                      ? "!text-[23px] leading-[30px]"
                      : "text-[24px]"
                  }`}
                >
                  {lang === "en"
                    ? enPhrase["lblUnregisterAppsConfirm"]
                    : arPhrase["lblUnregisterAppsConfirm"]}
                </p>

                <p className="text-[16px] font-Almarai text-[#666666] font-normal text-center">
                  {lang === "en"
                    ? enPhrase["lblDataLossWarning"]
                    : arPhrase["lblDataLossWarning"]}
                </p>
              </div>

              <div className="flex flex-col md:flex-row items-center justify-center gap-[16px]">
                <button
                  onClick={() => setIsDeleteAllRequestes(false)}
                  className="w-full md:w-[176px] h-[44px] border-[1px] border-solid border-[#E9DCC2] bg-[#E9DCC2] rounded-[4px]"
                >
                  <p className="text-[14px] font-Almarai text-[#361E12] font-bold">
                    {lang === "en"
                      ? enPhrase["lblBackToRequest"]
                      : arPhrase["lblBackToRequest"]}
                  </p>
                </button>

                <button
                  onClick={handleRefresh}
                  className="w-full md:w-[176px] h-[44px] border-[1px] border-solid border-[#B68A35] bg-[#B68A35] rounded-[4px]"
                >
                  <p className="text-[14px] font-Almarai text-[#FFFFFF] font-bold">
                    {lang === "en"
                      ? enPhrase["lblConfirm"]
                      : arPhrase["lblConfirm"]}
                  </p>
                </button>
              </div>
            </div>
          </SharedModal>
        )}

        {submitAllRequests && !isSubmitting && (
          <SharedModal
            isAdmission
            openModal={submitAllRequests}
            setOpenModal={setSubmitAllRequests}
          >
            <div className="flex flex-col items-center justify-center gap-[24px] sm:gap-[32px] py-[24px] sm:py-[40px] px-[24px] sm:px-[32px]">
              <img
                src="/assets/img/Caution.svg"
                alt=""
                className="w-[64px] h-[52px] sm:w-[80px] sm:h-[65.2px]"
              />
              <div className="flex flex-col justify-start items-start">
                <p
                  className={`text-[16px] w-full sm:text-[24px] text-[#010202]   font-Almarai  ${
                    lang === "en" ? "leading-[1.3]" : "leading-[1.67]"
                  } `}
                >
                  {lang === "en"
                    ? enPhrase["lblAdmissionText01"]
                    : arPhrase["lblAdmissionText01"]}
                </p>
                <p
                  className={`text-[16px] w-full sm:text-[24px] text-[#010202]  font-Almarai  ${
                    lang === "en" ? "leading-[1.3]" : "leading-[1.67]"
                  }`}
                >
                  {lang === "en"
                    ? enPhrase["lblAdmissionText02"]
                    : arPhrase["lblAdmissionText02"]}
                </p>
              </div>
              <div className="flex gap-[16px] flex-col-reverse sm:flex-row   w-full justify-center">
                <button
                  className="bg-[#F2ECCF] p-[8px] h-[44px] w-full sm:w-[317px] flex items-center justify-center rounded-[4px]"
                  onClick={() => setSubmitAllRequests(false)}
                >
                  <p className="text-[16px] font-Almarai text-[#815327] font-bold">
                    {lang === "en"
                      ? enPhrase["lblGoBackText"]
                      : arPhrase["lblGoBackText"]}
                  </p>
                </button>
                <button
                  className="bg-[#B68A35] p-[8px] h-[44px] w-full sm:w-[317px] flex items-center justify-center rounded-[4px]"
                  // onClick={termsHandler}
                  // onClick={handleSubmitAll}
                  onClick={() => {
                    setIsSubmitting(true);
                    setSubmitAllRequests(false);
                    caseDetailsRef.current.submitForm();
                    setLoading(true);
                  }}
                >
                  <p className="text-[16px] font-Almarai text-[#fff] font-bold">
                    {lang === "en"
                      ? enPhrase["lblAgreeText"]
                      : arPhrase["lblAgreeText"]}
                  </p>
                </button>
              </div>
            </div>
          </SharedModal>
        )}

        {loading && (
          <SharedModal
            isAdmissionLoading
            openModal={submitAllRequests}
            setOpenModal={setSubmitAllRequests}
          >
            <div className="flex flex-col items-center gap-[16px] py-[30px]">
              {loading ? (
                <Loader
                  color={"mainColor"}
                  imageSrc="/assets/img/add-request/LogoIcon.svg"
                  isRequest
                  circleThickness={1} // Outer circle thickness
                  pathThickness={1} // Path thickness (spinner line)
                />
              ) : null}
              <div className="flex flex-col items-center gap-[12px] px-[24px] text-center">
                <p className="font-Almarai font-bold text-[24px] text-[#010202] leading-[30px]">
                  {lang === "en"
                    ? enPhrase["lblAppsRegistering"]
                    : arPhrase["lblAppsRegistering"]}
                </p>
                <div
                  className={`bg-[#E0D1B4] ${
                    lang === "en" ? "w-[110px]" : "w-[80px]"
                  } h-[32px] py-[4px] px-[12px] flex flex-row items-center justify-between rounded-[100px]`}
                >
                  <p className="font-Almarai font-normal text-[16px] text-[#0E0D0C]">
                    {/* {Object.keys(disclosures).length} */}
                    {Object.keys(disclosureData).length}
                  </p>
                  <p className="font-Almarai font-normal text-[16px] text-[#0E0D0C]">
                    {lang === "en" ? "Requests" : "طلبات"}
                  </p>
                </div>
              </div>
            </div>
          </SharedModal>
        )}
      </div>
    </>
  );
};

export default RequestPage;
